import React, { useEffect, useRef, useState } from "react";
import { Button, Alert } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

const CameraController = ({
    preview,
    onPhotoTaken,
    onUpload,
    onRetake,
    onCancel
}) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" }
            });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (err) {
            setError("Camera access denied. Please allow camera permissions.");
        }
    };

    const stopCamera = () => {
        if (videoRef.current?.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(t => t.stop());
        }
    };

    useEffect(() => {
        startCamera();
        return () => stopCamera();
    }, []);

    const takePhoto = () => {
        setError("");
        setLoading(true);

        const canvas = canvasRef.current;
        const video = videoRef.current;
        if (!canvas || !video) {
            setError("Camera unavailable");
            setLoading(false);
            return;
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);

        const img = canvas.toDataURL("image/jpeg", 0.85);

        stopCamera();
        setLoading(false);

        onPhotoTaken(img);
    };

    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            {!preview && (
                <>
                    <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            marginBottom: 20,
                            background: "#000"
                        }}
                    />

                    <StepCompleteActionButton
                        label={loading ? "CAPTURING..." : "TAKE PHOTO"}
                        onClick={takePhoto}
                        disabled={loading}
                    />
                </>
            )}

            {preview && (
                <>
                    <img
                        src={preview}
                        alt="preview"
                        style={{ width: "100%", borderRadius: 8, marginBottom: 20 }}
                    />

                    <StepCompleteActionButton
                        label={loading ? "UPLOADING..." : "UPLOAD PHOTO"}
                        onClick={() => {
                            const canvas = canvasRef.current;
                            canvas.toBlob(
                                (blob) => onUpload(blob),
                                "image/jpeg",
                                0.85
                            );
                        }}
                        disabled={loading}
                    />

                    <Button className="w-100 mt-2" color="secondary" onClick={onRetake}>
                        RETAKE PICTURE
                    </Button>
                </>
            )}

            <canvas ref={canvasRef} style={{ display: "none" }} />
        </>
    );
};

export default CameraController;